import logo from "./hero.svg";
import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p style={{ marginTop: "60px" }}>Coming soon!</p>
      </header>
    </div>
  );
}

export default App;
